import { createConnector } from "react-instantsearch-dom";

const connectSearchBar = createConnector({
  displayName: "ConnectedSearchBar",
  getProvidedProps: (props, searchState, searchResults) => ({
    query: searchState?.query,
    store: props?.contextValue?.store,
    searchResults,
    searchState,
    props,
  }),
});

export default connectSearchBar;